<template>
  <div class="card">
    <div class="card__media">
      <AtomImage class="aspect-square" :src="post.image?.src?.medium" :alt="post?.image?.alt || post?.title" />
    </div>
    <div class="card__info">
      <p class="card__label" v-if="label">{{ label }}</p>
      <h2 class="card__heading">{{ post.title }}</h2>
      <p class="card__leading">{{ post.excerpt }}</p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  post: {
    type: Object,
    default: () => {}
  },
  label: {
    type: String,
    default: ''
  },
  imagePosition: {
    type: String,
    default: 'left'
  }
})
</script>

<style lang="scss" scoped>
.card {
  @apply @container;
  @apply relative flex items-center gap-3 md:gap-6 bg-mist rounded overflow-hidden;
  
  &__media {
    @apply w-full bg-black relative;
    @apply w-20 md:w-24;
  }

  &__info {
    @apply flex-1;
  }

  &__info {
    @apply grid gap-1;
  }
  
  &__heading {
    @apply font-bold md:text-xl;
  }

  &__leading {
    @apply text-sm line-clamp-1;
  }
}
</style>